export const logProduct = (
  product: string,
  company: string | undefined,
  title: string
) => {
  const _text = `${
    product.charAt(0).toUpperCase() + product.slice(1)
  } - ${title}${company ? ` - ${company}` : ''}`
}
